import { useQuery } from '@tanstack/react-query';
import { useOrgStore } from '@/stores/org-store';
import {
  listRunDays,
  type ListRunDaysParams,
  type RunDaysResponse,
} from '@/services/schedules/list-run-days';

export const runDaysQueryKey = (
  orgId?: string,
  params: ListRunDaysParams = {},
) => ['scheduled-run-days', orgId, params];

export const useListRunDays = (params: ListRunDaysParams = {}) => {
  const { currentOrg } = useOrgStore();
  const orgId = currentOrg?.orgid;

  return useQuery<RunDaysResponse, Error>({
    queryKey: runDaysQueryKey(orgId, params),
    queryFn: () => listRunDays(orgId!, params),
    enabled: !!orgId,
    staleTime: 30_000,
    retry: 1,
  });
};
